import { Dialog, DialogHeader, Typography } from "@material-tailwind/react";
import { DialogContent } from "@mui/material";
import Login from ".";

export interface LoginModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onSuccess: () => void;
}

const LoginModal = ({ open, setOpen, onSuccess }: LoginModalProps) => {
  return (
    <Dialog open={open} handler={setOpen}>
      <Login onSuccess={onSuccess} />
    </Dialog>
  );
};

export default LoginModal;
